import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { MEAT_API, CHAVE_API } from '../app.api';
import { Produto } from '../models/model';
import { Observable } from 'rxjs/Observable';
import { ErrorHandler } from '../app.error-handler';
import { DadosService } from './dados.service';
import 'rxjs/add/operator/catch';



@Injectable()
export class ProdutoService {

    private produto: Produto;

    constructor(private http: Http,
                private empresaService: DadosService) { }

    buscaProduto(filtro: { referencia: string,
                           produto: string}): Observable<Produto[]> {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('cnpj', this.empresaService.getEmpresa().dados.cnpj);
        headers.append('referencia', filtro.referencia);
        headers.append('nome', filtro.produto);
        headers.append('chave', CHAVE_API);
        return this.http.get(`${MEAT_API}/api/web/produtos`, new RequestOptions({ headers: headers }))
            .map((response) => response.json())
            .catch(ErrorHandler.handleError);
    }
}


// WEBPACK FOOTER //
// ./src/app/services/produto.service.ts